/**
 * Detects if the current browser is automated (bot, crawler, or testing framework).
 *
 * - Selenium, Puppeteer, Playwright set navigator.webdriver
 * - Lighthouse, HeadlessChrome, HeadlessFirefox, Googlebot, Bingbot, YandexBot, Applebot,
 *   Baiduspider, PhantomJS, and Prerender have distinctive user agent patterns
 */
const AUTOMATED_UA_PATTERNS = [
  'Lighthouse',
  'HeadlessChrome',
  'HeadlessFirefox',
  'Googlebot',
  'Bingbot',
  'YandexBot',
  'Applebot',
  'Baiduspider',
  'PhantomJS',
  'Prerender',
]
const AUTOMATED_UA_REGEX = new RegExp(AUTOMATED_UA_PATTERNS.join('|'), 'i')

let _isAutomatedBrowser: boolean | undefined

export function isAutomatedBrowser(): boolean {
  if (_isAutomatedBrowser !== undefined) return _isAutomatedBrowser

  if (typeof navigator === 'undefined') {
    _isAutomatedBrowser = false
  } else if (navigator.webdriver) {
    // WebDriver flag is set by Selenium, Puppeteer, Playwright, etc.
    _isAutomatedBrowser = true
  } else if (AUTOMATED_UA_REGEX.test(navigator.userAgent)) {
    // Known automated/bot user agent patterns that execute JavaScript
    _isAutomatedBrowser = true
  } else {
    _isAutomatedBrowser = false
  }

  return _isAutomatedBrowser
}

/** @internal Reset memoized value — for tests only */
export function resetIsAutomatedBrowser(): void {
  _isAutomatedBrowser = undefined
}
